module.exports = __webpack_public_path__ + "static/img/ilog-contact.a63a0b1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/contact/ilog-contact.png
// module id = kK7s
// module chunks = 1